<template>
	<div class="row justify-content-md-center">

		<div class="col-12 col-xl-8">

			<div class="row">
				<div class="col">

					<b-form-group class="pull-right">
						<b-btn variant="primary"
							v-b-tooltip.hover
							:title="$t('tag.add')"
							exact
							:to="{ name: 'tagAdd' }">
							<i class="fa fa-fw fa-plus"></i>
						</b-btn>
						<b-btn variant="outline-secondary"
							v-b-tooltip.hover
							title="Terug"
							exact
							:to="{ name: 'Landingpage' }">
							<i class="fa fa-fw fa-reply"></i>
						</b-btn>
					</b-form-group>

					<h1 class="display-4"> {{ $t('tag.list') }}</h1>

					<b-alert v-if="error"
							variant="danger"
							show>{{ error }}</b-alert>
				</div>
			</div>


			<partial-loader :loading="isFetching"></partial-loader>

			<b-table v-if="!isFetching"
					 
					striped
					hover
					show-empty
					:items="tags"
					:fields="fields"
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					:busy="isFetching"
					:empty-text="$t('tag.listEmptyText')"
					:empty-filtered-text="$t('tag.listEmptyFilteredText')">

				<template v-slot:cell(hidden)="row">
					{{ row.item.hidden ? 'Ja' : 'Nee' }}
				</template>

				<template v-slot:cell(actions)="row">
					<b-btn-group class="pull-right">
						<b-btn variant="outline-danger" @click="showDeleteModal(row.item)"><i class="fa fa-fw fa-trash"></i></b-btn>
						<b-btn variant="outline-primary" :to="{ name: 'tagEdit', params: { tagId: row.item.id } }"><i class="fa fa-fw fa-edit"></i></b-btn>
					</b-btn-group>
				</template>

			</b-table>

			<delete-dialog-modal ref="deleteModal"
				:delete-name="selectedDeleteTagName"
				:item="selectedDeleteTag"
				:isDeleting="isDeletingTag"
				@confirm="confirmDeletion"
			/>
		</div>
	</div>
</template>

<script>
import { isNil } from 'lodash';
import PartialLoader from '@/components/elements/PartialLoader';
import DeleteDialogModal from '@/components/elements/Edit/DeleteDialogModal';
import { flashSuccess } from '@/helpers/flash-message-helper';
import { mapGetters, mapActions } from 'vuex';

export default {
	components: {
		PartialLoader,
		DeleteDialogModal
	},
	data() {
		return {
			error: null,
			fields: [
                { key: 'id', label: 'ID' },
				{ key: 'name', label: 'Naam' },
				{ key: 'hidden', label: 'Onzichtbaar'},
				{ key: 'actions', label: this.$t('common.actions'), class: 'text-right' }
			],
			sortBy: 'id',
			sortDesc: false,
			selectedDeleteTag: null,
		}
	},
	computed: {
        ...mapGetters([
			'isFetchingTags',
			'isDeletingTag',
            'tags',
        ]),
        isFetching: function() {
            return this.isFetchingTags;
        },
		selectedDeleteTagName() {
			if (!this.selectedDeleteTag) return '';

			return 'de tag ' + this.selectedDeleteTag.name;
		}
	},
	watch: {
		'$route': 'initialize'
	},
	methods: {
        ...mapActions([
			'fetchTags',
			'deleteTag',
        ]),
		initialize() {
            this.fetchTags();
		},
		showDeleteModal(tag) {
			this.selectedDeleteTag = tag;
			this.$refs.deleteModal.show();
		},
		async confirmDeletion() {
			await this.deleteTag(this.selectedDeleteTag.id);
			this.$refs.deleteModal.hide();
			this.initialize();
		}
	},
	mounted() {
		this.initialize();
	}
}
</script>

<style lang="scss">
</style>




// WEBPACK FOOTER //
// TagList.vue?23d4a39c